import { CheckOutlined } from "@ant-design/icons";

type IndicatorProps = {
  actualDate: string | null;
  isCurrentMilestone: boolean;
  /** Opaque fill so a sibling connector line does not show through the circle. */
  maskCenterConnector?: boolean;
};

function ProgressIndicatorCircle(props: IndicatorProps) {
  const { actualDate, isCurrentMilestone, maskCenterConnector } = props;
  const connectorMaskClass = maskCenterConnector
    ? "relative z-10 bg-white"
    : "";

  if (!actualDate)
    return (
      <div
        className={
          isCurrentMilestone
            ? `bl-circle !border-2 border-ciq-primary-900 ${connectorMaskClass}`
            : `bl-circle ${connectorMaskClass}`
        }
      />
    );

  return (
    <div className={`bl-circle ${connectorMaskClass}`}>
      <div className="w-full h-full text-xs rounded-[70%] flex items-center justify-center">
        <CheckOutlined />
      </div>
    </div>
  );
}
export default ProgressIndicatorCircle;
